import { StateSchema } from 'app/config/storeConfig/types';

export const getOpenedState = (state: StateSchema): boolean => state.createUserModal.isOpened;
